import { ResponseGetMerchflows_merchflowId_BasePog_basePogId_ } from "@CommonApi/merchflows/_merchflowId_/base-pog/_basePogId_";
import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetMerchflowBasePog_basePogId_ = "/merchflow/base-pog/:basePogId";

export type ResponseGetMerchflowBasePog_basePogId_ =
  ResponseGetMerchflows_merchflowId_BasePog_basePogId_;

export const RoutePostMerchflowBasePog_basePogId_ = "/merchflow/base-pog/:basePogId";

export interface PayloadPostMerchflowBasePog_basePogId_ {
  pog: PogNonCircular;
  saveAsNew: boolean;
  saveProductsCdtsGlobally: boolean;
}

export interface ResponsePostMerchflowBasePog_basePogId_ {
  basePogId: number;
  updatedProductCdtsGlobally?: {
    productsCount: number;
    storesCount: number;
  };
}
